import { FC } from 'react';
import { ic_heart_rate, ic_heart_rate_active } from '.';

const HRVMenuIcon: FC<{ width?: number; primary?: boolean }> = ({ width = 24, primary }) => {
  if (primary) {
    return <img src={ic_heart_rate_active} width={width} alt="" />;
  }
  return <img src={ic_heart_rate} width={width} alt="" />;
};

export default HRVMenuIcon;
